import React, {useState, useEffect} from "react";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import ConfettiFullScreen from "./confettiFullscreen";
import LessonsProgressbar from "./lessons_progressbar";
import OptionalLessons from "./optional_lessons.js";
import { setFinishedCourse, setActivePart, setActiveLesson} from "../../../actions";
import Typewriter from 'typewriter-effect';
import t from "../../translate";
/* import doneSVG from '../../../images/course/standard/svg/done.svg';
import activeSVG from '../../../images/course/standard/svg/active.svg';
import lockedSVG from '../../../images/course/standard/svg/locked.svg'; */
import activeSVG from '../../../images/course/standard/svg/alt_item_active.svg';
import doneSVG from '../../../images/course/standard/svg/alt_item_finished.svg';
import lockedSVG from '../../../images/course/standard/svg/alt_item_locked.svg';
import { checkNestedProperties } from "../../utils";


const LessonsAltMenu = () => {

  const dispatch = useDispatch();
  const history = useHistory();

  const auth = useSelector(state => state.auth);
  const intervention = useSelector(state => state.intervention);
  const allAnswers = useSelector(state => state.answersLessons);
  const courseFinished = useSelector(state => state.finishedCourse);

  const [lessonList, setLessonList] = useState([]);
  const [illustration, setIllustration] = useState('');

  //tbv flipcard
  const [showCards, setShowCards] = useState([])

  const lessonStarted = (lesson_id) => {
    let currentLessonAnswers = allAnswers.answers.find((answer) => {
      return parseInt(answer.the_id) === parseInt(lesson_id)
    });
    if (typeof currentLessonAnswers !== 'undefined' &&  currentLessonAnswers.hasOwnProperty('started') && currentLessonAnswers.started === true)
    {
      return true;
    }
    else
    {
      return false;
    }
  }

  const lessonFinished = (lesson_id) => {
    let currentLessonAnswers = allAnswers.answers.find((answer) => {
      return parseInt(answer.the_id) === parseInt(lesson_id)
    });
    if (typeof currentLessonAnswers !== 'undefined' &&  currentLessonAnswers.hasOwnProperty('finished') && currentLessonAnswers.finished === true)
    {
      return true;
    }
    else
    {
      return false;
    }
  }

  const getActiveLessonLink = (lesson_id, index) => {
    if(lessonList[index].status == 'active'){

      let aFinishedLesson = false;
      let anActiveLesson = false;
      for (const lesson of intervention.settings.selfhelp.lessons) {

        if ((lesson.id == lesson_id) || (parseInt(lesson.parent_id) === parseInt(lesson_id) && (!lesson.hasOwnProperty('sub_id') || parseInt(lesson.sub_id) === 0)))
        {
          if (!anActiveLesson && !lessonFinished(lesson.id))
          {
            lesson_id = lesson.id
            break;
          }
        }
      }
      return lesson_id
    } else {
      return lesson_id
    }
  }
  const changeActiveLesson = (lesson_id, index) => {

    /// ga na welke les actief is in de actieve les
    lesson_id = getActiveLessonLink(lesson_id, index)
    dispatch(setActivePart("lesson"));
    dispatch(setActiveLesson(lesson_id));
    history.push("/course/" + intervention.id + "/lesson/" + lesson_id);

  }

  const fakeEmptyFunc = () => {
    //om react tevreden te stellen
  }

  //actieve les bepalen -> les waar nog onafgeronde lessen in zitten
  useEffect(() => {

    if (intervention.settings.selfhelp.lessons.length < 1) {
        return;
    }

    let newlessonList = [];
    let unregisteredLesson = {
      id: 0,
      title: '',
      status: 'closed'
    };
    let lastLessonStatus = 'finished';
    let allFinished = true;
    let started = false;
    let someFinished = false;
    let lastFinished = false;

    for (const lesson of intervention.settings.selfhelp.lessons) {

      if (parseInt(lesson.parent_id) === 0 && parseInt(lesson.sub_id) === 0) //les op hoofdniveau
      {
        if (unregisteredLesson.title.length > 0)
        {
          //if (allFinished)
          if (lastFinished)
          {
            unregisteredLesson.status = 'finished';
          }
          else
          {
            if (someFinished)
            {
              unregisteredLesson.status = 'active';
            }
            else
            {
              unregisteredLesson.status = 'closed';
            }
          }
          if (unregisteredLesson.status === 'closed' && lastLessonStatus === 'finished') {
            unregisteredLesson.status = 'active';
          }
          lastLessonStatus = unregisteredLesson.status;
          newlessonList.push(unregisteredLesson);
          if (unregisteredLesson.status === 'active') {
            let activeLesson = intervention.settings.selfhelp.lessons.find(lesson => {
              return parseInt(lesson.id) === parseInt(unregisteredLesson.id)
            })
            setIllustration(typeof activeLesson.settings.image != 'undefined' ? activeLesson.settings.image :'')
          }
        }
        let alternative_menu_image = '';
        if (typeof lesson.alternative_menu_image !== "undefined")
        {
          alternative_menu_image = lesson.alternative_menu_image;
        }
        unregisteredLesson = {
          id: lesson.id,
          title: lesson.title,
          alternative_menu_image,
          status: 'closed'
        };
        allFinished = true;
        someFinished = false;
      }

      //bepalen of les is afgerond...
      let lessonAnswers = allAnswers.answers.find((answer) => {
        return parseInt(answer.the_id) === parseInt(lesson.id)
      });
      if (typeof lessonAnswers === 'undefined' || !lessonAnswers.hasOwnProperty('finished') || lessonAnswers.finished === false)
      {
        allFinished = false;
        lastFinished = false;
      }
      else
      {
        someFinished = true;
        lastFinished = true;
      }
    }

    //if (allFinished)
    if (lastFinished)
    {
      unregisteredLesson.status = 'finished';
    }
    else
    {
      if (someFinished)
      {
        unregisteredLesson.status = 'active';
      }
      else
      {
        unregisteredLesson.status = 'closed';
      }
    }
    if (unregisteredLesson.status === 'closed' && lastLessonStatus === 'finished') {
        unregisteredLesson.status = 'active';
      }
      lastLessonStatus = unregisteredLesson.status;
    newlessonList.push(unregisteredLesson)
    if (unregisteredLesson.status === 'active') {
      let activeLesson = intervention.settings.selfhelp.lessons.find(lesson => {
        return parseInt(lesson.id) === parseInt(unregisteredLesson.id)
      })
      setIllustration(typeof activeLesson.settings.image != 'undefined' ? activeLesson.settings.image :'')
    }

    if(allFinished){ /// find last lesson image and set image of that lesson
      for(let i = intervention.settings.selfhelp.lessons.length - 1 ; i >= 0 ; i-- ){
        if(intervention.settings.selfhelp.lessons[i].parent_id == 0){
          setIllustration(typeof intervention.settings.selfhelp.lessons[i].settings.image != 'undefined' ? intervention.settings.selfhelp.lessons[i].settings.image :'')
          break;
        }
      }

    }
    //opschonen -> tbv bug dat niet iedere les altijd op finished wordt gezet en er dan meerdere lessen actief zijn...
    /* let foundactive = false;
    for (var i = newlessonList.length -1;i>=0;i--) {
      if (newlessonList[i].status === 'active')
      {
        if (!foundactive)
        {
          foundactive = true;
        }
        else
        {
          newlessonList[i].status = 'finished';
        }
      }
    }
    */
    setLessonList(newlessonList);

    if(courseFinished){
      setEndCourse('true');
      dispatch(setFinishedCourse(false));
    }

  }, [intervention, allAnswers]);

  const [endCourse, setEndCourse] = useState(false)

  const goBaseline = () => {
    dispatch(setActivePart("baseline"));
    history.push("/baseline/");
  }

  function flipCard(index){
    let showCardsNew = [...showCards]
    if(showCardsNew.includes(index)){
      let indexOfIndex = showCardsNew.indexOf(index);
      if (indexOfIndex !== -1) showCardsNew.splice(indexOfIndex, 1);
    } else {
      showCardsNew.push(index)
    }
    setShowCards(showCardsNew)
  }

  return(
    <div className='lessons'>
        <div className="welkom">{t("Welkom bij")}</div>
        <div className="title"><span dangerouslySetInnerHTML={{__html: intervention.title}} /></div>
      {/* {typeof intervention.settings.subtitle != "undefined" && intervention.settings.subtitle != "" ?
        <div className="title">
          <h1 id="typed_1" className="subTitle"><Typewriter options={{delay:40}}
          onInit={(typewriter) => {
            typewriter.typeString(t(intervention.settings.subtitle))
              .callFunction(() => {
                document.getElementById("typed_1").className = "finished subTitle"
              })
              //.pauseFor(2500)
              //.deleteAll()
              .start();
          }}
          /></h1>
          <h1 className="dummy">{intervention.settings.subtitle}</h1>
        </div>
      :''} */}

        {
          typeof intervention !== "undefined" && typeof intervention.settings !== "undefined" && typeof intervention.settings.coverPhoto !== "undefined" && intervention.settings.coverPhoto.length > 0 ?
            <div className="illustration">
              <img src={intervention.settings.coverPhoto} />
            </div>
          :
            ''
        }

      <div className="lessonsHolder">
        {
          //'Start hier: Waar sta je nu?' uit op edu (geen voor-/nameting)
          false && auth.doT0 ?
          <div className="items" style={{marginTop: '70px', background: 'none'}} onClick={()=>goBaseline()} >
            <div className="item active">
                <span style={{paddingLeft: '20px'}}>{t("Start hier: Waar sta je nu?")}</span>
            </div>
          </div> : <></>
         }
        <div className="intro">
          <h2>{typeof intervention.settings.menu != "undefined" ? intervention.settings.menu.modules:''}</h2>
          {typeof intervention.settings.lessonsIntro != 'undefined' &&  intervention.settings.lessonsIntro != '' ? intervention.settings.lessonsIntro:''}
        </div>
        <div className="items_alt">
        {
          //alternatief menu (niet seqentieel, met plaatjes)
          lessonList.map((lesson, index) => {
            if (auth.doT0) {
              lesson.status = 'closed'
            }
            if (lesson.title.length > 8 && lesson.title.substr(0, 9).toLowerCase() === '[heading]') {
              return false;
            } else {
              if (!checkNestedProperties(intervention, 'settings', 'selfhelp', 'alternative_menu_flipcard') || intervention.settings.selfhelp.alternative_menu_flipcard === false) {
                return (
                <div key={index} className={'pointer item_alt '+lesson.status} onClick={(lesson.status === 'finished' || lesson.status === 'active') ? ()=>changeActiveLesson(lesson.id, index) : ()=>fakeEmptyFunc()} style={lesson.status === 'active' ? {border: '1px solid #000'} : lesson.status === 'closed' ? {cursor: 'not-allowed'} : {}}>
                {/* <div key={index} className={'pointer item_alt '+lesson.status} onClick={() => changeActiveLesson(lesson.id, index)}> */}
                  <div className="title">{lesson.title}</div>
                  <div className="image" style={{backgroundImage: (typeof lesson.alternative_menu_image !== "undefined" && lesson.alternative_menu_image.length > 0) ? 'url("'+lesson.alternative_menu_image+'")' : ''}}></div>
                  {
                      <div className="activated">
                        <div className="vinkseq">
                          {
                            lesson.status === 'active' ? <img src={activeSVG} />
                              :
                            <> { lesson.status === 'closed' ? <img src={lockedSVG} /> : <img src={doneSVG}/> } </>
                          }
                        </div>
                      </div>
                  }
                </div>
                )
              } else {
                //flipcard tonen...
                return(
                  <div className={"flip-card pointer " + (showCards.includes(lesson.id) ? 'back':'front')} onClick={() => flipCard(lesson.id)}>
                    <div className="inner">
                      <div className="front" style={lesson.status === 'active' ? {border: '1px solid #e76d71'} : {}}>
                        <div className={'title '+lesson.status}>{lesson.title}</div>
                        <div className={'image '+lesson.status} style={{backgroundImage: (typeof lesson.alternative_menu_image !== "undefined" && lesson.alternative_menu_image.length > 0) ? 'url("'+lesson.alternative_menu_image+'")' : ''}}></div>
                        <div className='activated'>
                          <div className="vinkseq">
                            {
                              lesson.status === 'active' ? <img src={activeSVG} /> : 
                                <>
                                  {
                                  lesson.status === 'closed' ? <img src={lockedSVG} /> : <img src={doneSVG}/>
                                  }
                                </>
                            }
                          </div>
                        </div>
                    </div>
                      <div className="back" style={lesson.status === 'active' ? {border: '1px solid #e76d71'} : {}}>
                        <div className="flip-card-text">{checkNestedProperties(intervention, 'settings', 'selfhelp', 'alternative_menu_flipcardtexts', lesson.id) ? intervention.settings.selfhelp.alternative_menu_flipcardtexts[lesson.id] : ''}</div>
                        <button className="btn btn-primary" onClick={(e) => changeActiveLesson(lesson.id, index)}>{t("Start module")}</button>
                      </div>
                    </div>

                    {
                    lesson.status !== 'closed' ?
                      <div className="activated">
                        <div className="vinkseq">
                          <div className="image">
                            <img src={doneSVG}/>
                          </div>
                          {/* <div className="tekst">{t("Aangeschaft")}</div> */}
                        </div>
                      </div> : <></>
                    }

                  </div>)
              }
            }
          })
        }
        </div>
      </div>
      {endCourse  ? <ConfettiFullScreen setEndCourse={setEndCourse}/>:''}
      <OptionalLessons lessonList={lessonList}/>
    </div>
  )
}

export default LessonsAltMenu;
